module.exports = __webpack_public_path__ + "fonts/sam-icons.a6e672a.woff";